export default class mailEditorBlocks {
    constructor() {
        return {
            restrict: 'E',
            controller: EditorBlockCtrl,
            template: require('../../../../views/maileditor/mail-editor-blocks.html'),
            controllerAs: 'block'
        }
    }
};

class EditorBlockCtrl {
    constructor($scope, $element, BlockService) {
        this._scope = $scope;
        this._element = $element;

        this.blockService = BlockService;

        this._scope.$on('mailEditor:template:parseTemplate', (event, source) => {
            let blocks = $(source).find('.iguana-duplicatable, .iguana-switch');
            let blockNr = 1;

            _(blocks).forEach((block) => {
                if ($(block).data('rule-block-name')) {
                    this.blockService.add(blockNr++ + ". " + $(block).data('rule-block-name'), block);
                } else {
                    this.blockService.add(blockNr++ + ". Block", block);
                }
            });
        });
    }

    all() {
        return this.blockService.get();
    }
    
    drawn() {
        angular.forEach(this._element.find('.block'), (block) => {
            $(block).on('dragstart', (event) => {
                event.originalEvent.dataTransfer.setData('rule/block', $(block).data('rule-block-name'));
                $('.drop-zone').show();
            }).on('dragend', () => {
                $('.drop-zone').hide();
            });
        });
    }
}
